import { createContext, useContext } from 'react';
export const MigrateOpeningHoursContext = createContext(null);
export const useMigrateOpeningHoursContext = () => {
    const context = useContext(MigrateOpeningHoursContext);
    if (!context) {
        throw new Error('No MigrateOpeningHoursContext');
    }
    return context;
};
